// Seller-side findings at goods-in that justify refusing a Widerruf refund.
// Mirrors Cancellation::REJECTION_CAUSES in the API (app/Models/CityOffer/
// Cancellation.php) — the backend validates against the same closed set, and
// marketplace bridges map it 1:1, so the order and the keys must not drift.
//
// Labels are NOT here: every consumer translates the keys through its own
// <i18n> block, the same way `rejection_reason` (admin | expired) is handled.
export const REJECTION_CAUSES = [
    'returned-wrong-item',
    'exchange-requested',
    'item-missing-in-parcel',
    'third-party-item',
    'hygiene-seal-broken',
    'item-damaged-by-customer',
    'return-period-exceeded',
];

export default REJECTION_CAUSES;
